module.exports = __webpack_public_path__ + "img/thumbnail_HimalayanBrownBear_f_normal.3c161d6a.png";